<template>
    <b-overlay :show="loading">

        <b-alert v-if="error" show variant="danger" class="mt-2">
        System error - contact tech support.
        <!-- TBD error component. -->
        </b-alert>

        <b-row v-for="row in podcasts" ref="rows" v-bind:key="row.classId" class="mt-4 pointer" @click.stop.prevent="gotoPodcast(row.podcastShowHash,row.hash)">
            <b-col cols="4" class="text-center">
            <certbutton :c="buildClass(row)" :s="buildStudentData(row)"></certbutton>
            </b-col>
            <b-col cols="8" style="margin-left: -20px;">
            <div class="class-title">{{row.title}}</div>
            <div class="class-details">
                {{row.speakerName}}
                <br>Sponsor: {{row.sponsorCompanyName}}
                <br>{{row.releaseDate | prettyDate}} - {{row.credits}} CEU ({{row.ceTypeId | prettyCEType}})
            </div>
            </b-col>
        </b-row>

        <b-row v-if="!loading && pages > 1" class="mt-4">
            <b-col>
            <b-pagination align="center" v-model="curPage" :total-rows="totalRows" :per-page="pageSize" @change="pageChange" @input="pageInput"></b-pagination>
            </b-col>
        </b-row>

  </b-overlay>
</template>

<script>
/* eslint-disable */

import service from "@/service/service";
import utils from "@/utils/utils";

var data = {
  debug: false,
  error: false,
  loading: true,
  studentHash: '',
  title: "CE Completed Podcasts",
  blurb: "",
  podcasts: [],
  totalRows: 0,
  pageSize: 0,
  pages: 0,
  curPage: 1,
  bannerAds: []
}

export default {
  name: "CompletedPodcasts",
  data() {
    return data;
  },
  props: {
    page: {
      type:String,
      required: false,
      default: '1'
    }
  },
  computed: {
    rows () {
      return this.podcasts.length
    },
    studentName() {
      let name = this.$root.getStudentName()
      if (name.length === 0) {
        this.$router.push('/login')
      }
      return name
    }
  },
  methods: {
    gotoPodcast(podcastShowHash,podcastHash) {
      this.$router.push(`/podcast/${podcastShowHash}/${podcastHash}`)
    },
    pageInput(page) {
      // console.log(`pageInput: ${page}`)
    },
    pageChange(page) {
      this.curPage = page
      this.doCompleted()
      // console.log(`pageChange: ${page}`)
    },
    linkGen(pageNum) {
      let link = `/completed/${pageNum}`
      console.log(`pageNum: ${pageNum}  link: ${link}`)
      return link
    },
    setCurPage() {
      try {
        this.curPage = parseInt(this.page)
        if (this.curPage <= 0) this.curPage = 1
      }
      catch(e) {
        this.curPage = 1
      }
      // console.log( `this.page: ${this.page}  curPage: ${this.curPage}`)
    },
    buildClass(podcast) {
      let aout = {
        status: true,
        classId: podcast.id,
        className: podcast.title,
        speakerName: null,  // speaker name not used
        podcastHash: podcast.hash,
        description: podcast.description,
        classHash: null
      }
      return aout
    },
    buildStudentData(data) {
      let aout = {
        status: true,
        hash: this.studentHash,
        name: this.$root.getStudentName(),
        examDate: data.examDate,
        credits: data.credits,
        ceTypeId: data.ceTypeId
      }
      return aout
    },
    doCompleted() {
      this.loading = true
      this.podcasts = []
      service
        .getCompletedPodcasts(this.studentHash, this.curPage-1)
        .then(res => {
          if (this.debug) console.log(res)
          if (res.status && res.rowCount !== 0) {
            // this.blurb = `Completed: ${res.rowCount}`
            this.podcasts = res.data
            this.totalRows = res.totalRows
            this.pageSize = res.pageSize
            this.pages = (res.pageSize) ? Math.ceil( this.totalRows/res.pageSize ): 0
            if (this.curPage > this.pages) this.curPage = this.pages
          } else {
            this.blurb = "No podcasts completed.";
          }
        })
        .finally(() => this.loading = false)
        .catch(e => console.log(e))
    }
  },
  created() {
    this.studentHash = this.$root.getToken()
    // console.log(`page: ${this.page}  h: ${this.studentHash}`)
    this.setCurPage()
    this.doCompleted()
  },
  mounted() { console.log('mounted') },
  beforeDestroy() { console.log('destroy') }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/CompletedPodcast.vue